import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["size", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { transparentize } from 'polished';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Loader.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var ROOT_SIZES = {
  small: [15, 15],
  large: [32, 32],
  xlarge: [48, 48]
};
var BaseLoader = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(views.Root, _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: ROOT_SIZES[size][0],
    height: ROOT_SIZES[size][1],
    ref: ref,
    "data-testid": "loader"
  }, rest), {}, {
    children: _jsxs(views.Group, {
      children: [_jsx(views.Background, _objectSpread({
        cx: "16",
        cy: "16",
        r: "14.5"
      }, tokens.background)), _jsx(views.Foreground, _objectSpread({
        d: "M16 1.5a14.5 14.5 0 1 1 0 29"
      }, tokens.foreground))]
    })
  }));
});
export var Loader = withDesignTokens(BaseLoader, function (_ref2, theme) {
  var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? "normal" : _ref2$variant;

  switch (variant) {
    case "contrast":
      return {
        background: {
          color: transparentize(0.76, theme.palette.neutrals.white[100])
        },
        foreground: {
          color: theme.palette.twilio.gray[20]
        }
      };

    case "normal":
    default:
      return {
        background: {
          color: theme.palette.twilio.gray[20]
        },
        foreground: {
          color: theme.palette.twilio.gray[40]
        }
      };
  }
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});